// event.key codes
export const ARROW_LEFT = 'ArrowLeft';
export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_DOWN = 'ArrowDown';
export const ARROW_UP = 'ArrowUp';

export const ENTER_KEY = 'Enter';
export const ESC_KEY = 'Escape';
export const TAB_KEY = 'Tab';
export const BACKSPACE_KEY = 'Backspace';
export const SPACEBAR = ' ';
